import moment from "moment-timezone";
import { useParams } from "next/navigation";
import { usePortfolioScore } from "utils/clientAPIs/portfolio";
import { useEffect, useState } from "react";


const usePortfolioScoreUtil = (portId: number) => {
    const [hashId, setHashId] = useState<string | null | undefined>(undefined);
    const { data, isLoading, isError } = usePortfolioScore(Number(portId), hashId);
    useEffect(() => {
        const hashId = localStorage.getItem('pf-hashId');
        setHashId(hashId ?? null);
    }, []);


    // 포트폴리오 평균 점수 - 각 종목 점수 평균 mean
    const mean = data
        ? data?.reduce((acc: number, curr: any) => acc + curr.TOTAL_PER, 0) /
        data?.length
        : null;

    const max = data ? data?.reduce((acc: any, curr: any) => {
        return moment(acc.BASE_DT).isAfter(moment(curr.BASE_DT)) ? acc : curr;
    }, data[0]) : null;
    const maxBaseDt = max ? moment(max.BASE_DT).format("M월 D일") : null;

    const sortedData = data ? data?.sort((a: any, b: any) => b.TOTAL_PER - a.TOTAL_PER) : null;

    return { data: sortedData, mean, maxBaseDt, isLoading, isError };
};

export default usePortfolioScoreUtil;